import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
/**
 * Generated class for the FormCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "review-systems-card",
  templateUrl: "review-systems-card.html",
})
export class ReviewSystemCard implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  label: string;
  declinable: boolean;
  cardData: any;
  formGroup: FormGroup;
  inputKeys: Array<string>;
  inputs: [{}];
  initialized: boolean = false;
  access: string;

  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.label = this.config.cardName;
    this.declinable = this.config.declinable;
    this.access = this.config.access;

    this.formGroup = this.formBuilder.group({});
    this.formGroup.valueChanges.subscribe((dt) => {
      if (dt) {
        for (let data of this.config.sections) {
          let keys = Object.keys(data.inputs);
          for (let key of keys) {
            if (dt[key] && dt[key] === true) {
              data.inputs[key + "Text"].disable = false;
            }
          }
        }
      }
    });

    let val = [];
    for (let data of this.config.sections) {
      let totalKeysNumber = Object.keys(data.inputs).length;
      let keys = Object.keys(data.inputs);
      for (let i = 1; i <= totalKeysNumber; i++) {
        let key = "";
        for (let newKeys of keys) {
          if (data.inputs[newKeys].sortOrder === i) {
            key = newKeys;
            break;
          }
        }
        if (key.indexOf("Text") <= 0) {
          val.push(key);
        }
        this.formGroup.addControl(key, this.formBuilder.control(undefined));

        let selfControl = this.formGroup.controls[key];

        var validators = [];
        if (
          data.inputs &&
          data.inputs[key].rules &&
          data.inputs[key].rules.required
        ) {
          validators.push(Validators.required);
        }

        if (
          data.inputs &&
          data.inputs[key].rules &&
          data.inputs[key].rules.minLength
        ) {
          validators.push(
            Validators.minLength(data.inputs[key].rules.minLength)
          );
        }

        if (
          data.inputs &&
          data.inputs[key].rules &&
          data.inputs[key].rules.maxLength
        ) {
          validators.push(
            Validators.maxLength(data.inputs[key].rules.maxLength)
          );
        }
        var composedValidators: ValidatorFn = Validators.compose(validators);
        selfControl.setValidators(composedValidators);
      }
    }
    this.inputKeys = val;
  }

  translateOtherLabel(label: string) {
    var stringContainsOther = label.includes("other");

    if (stringContainsOther) {
      return "Other";
    } else {
      return label;
    }
  }

  @Input() set data(incomingData: any) {
    if (incomingData && incomingData.data && incomingData.data[0]) {
      let keys = Object.keys(incomingData.data[0]);
      for (let key of keys) {
        if (this.formGroup.controls[key] && incomingData.data[0][key]) {
          this.formGroup.controls[key].setValue(incomingData.data[0][key]);
        }
      }
    }

    if (incomingData !== undefined && !this.initialized) {
      // console.log( "Flagging dynamic form as initialized.", this.id );
      this.initialized = true;
      this.onCardInitialized.emit(this.config.id);
    }
  }

  checkboxClick(data, item) {
    if (data.checked === true) {
      item.disable = false;
    } else {
      item.disable = true;
      this.formGroup.controls[item.componentId].setValue(null);
    }
    this.emitValue();
    this.cdRef.detectChanges();
  }

  viewMore(item) {
    item.expandable = !item.expandable;
    this.cdRef.detectChanges();
  }

  emitValue() {
    this.onDataUpdate.emit({
      cardId: this.config.id,
      value: this.formGroup.value,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/review-systems-card/review-systems-card.ts